// these ids needed for nested modals since modal close logic was a little bit changed in ngx-bootstrap:6.1.0

export const CATEGORIES_MODAL_ID = '1';
export const REPLY_TEMPLATE_MODAL_ID = '2';
export const ATTACHMENTS_MODAL_ID = '3';
export const DOCUMENT_VIEWER_MODAL_ID = '4';
